import { EasTabItem, EasTabs } from '@easyvaas/react-components';
import React from 'react';
import { useRecoilState } from 'recoil';
import { subTabState } from '../../store/state';
import FightingRank from './FightingRank';
import styles from './index.module.scss';
import NumberRank from './NumberRank';
const ImageRank = () => {
  const tab = useRecoilState(subTabState(1));
  return (
    <EasTabs
      className={styles.container}
      tabControl={tab}
      tabbarClassName={styles.tabbar}
      tabbarItemClassName={styles.item}
      tabbarItemActiveClassName={styles.active}
    >
      <EasTabItem title="拥有座驾数量排行">
        <NumberRank />
      </EasTabItem>
      <EasTabItem title="座驾战斗力排行">
        <FightingRank />
      </EasTabItem>
    </EasTabs>
  );
};

export default React.memo(ImageRank);
